import { Container } from '@mui/material';

import useMarkdownFile from '../../hooks/useMarkdownFile';
import dataPrivacy from '../../markdowns/dataPrivacy.md';

const DataPrivacy = () => {
  const { markdownContent } = useMarkdownFile(dataPrivacy);

  return <Container>{markdownContent}</Container>;
};

export default DataPrivacy;
